/**
 * Display Settings Page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { pwaPath } from '@/utils/getBasePath';
import { ArrowLeft, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { useDisplay } from '../context/DisplayContext';
import { PwaAccountCard } from '@/components/pwa/PwaAccountGate';

export default function SettingsPage() {
  const { soundEnabled, setSoundEnabled } = useDisplay();

  return (
    <div className="min-h-screen bg-slate-900 p-6">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Link to={pwaPath('display')}>
            <Button variant="ghost" size="icon" className="text-slate-400">
              <ArrowLeft className="w-6 h-6" />
            </Button>
          </Link>
          <h1 className="text-2xl font-bold text-white">Display Settings</h1>
        </div>

        <div className="space-y-6">
          {/* Sound */}
          <div className="bg-slate-800 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <Bell className="w-5 h-5 text-blue-400" />
              Sound
            </h2>
            
            <div className="flex items-center justify-between">
              <div>
                <p className="text-white font-medium">Sound alerts</p>
                <p className="text-sm text-slate-400">Announcement for ready orders</p>
              </div>
              <Switch checked={soundEnabled} onCheckedChange={setSoundEnabled} />
            </div>
          </div>

          {/* Restaurant account: sign this screen out */}
          <PwaAccountCard />

        </div>
      </div>
    </div>
  );
}
